import { GhostAI } from './GhostAI';
import Ghost, { GhostState } from '../Ghost';
import { tileSize } from '~/src/consts/sizes';
import { Moves } from '../grid/grid';

export default class IdleAI implements GhostAI {
	private readonly ghost: Ghost;
	public targetPosition: Required<Phaser.Types.Math.Vector2Like> = { x: 0, y: 0 };
	public speed = 0;
	private readonly yMid = 528;


	constructor(ghost: Ghost, move: Moves) {
		this.ghost = ghost;
		this.ghost.ghostState = GhostState.Idle;
		this.speed = 4 * tileSize;
		this.targetPosition = move === Moves.Up
			? { x: this.ghost.x, y: 400 }
			: { x: this.ghost.x, y: 656 };
		this.ghost.setPosition(...(move === Moves.Up
			? [this.ghost.x, this.yMid + tileSize]
			: [this.ghost.x, this.yMid - tileSize]
		));
	}

	chooseTarget() {
		const yMin = this.yMid - tileSize;
		const yMax = this.yMid + tileSize;

		const { x, y } = this.ghost;
		if (y <= yMin) {
			this.targetPosition = { x, y: yMax };
			this.ghost.changeDirection(Moves.Down);
		} else if (y >= yMax) {
			this.targetPosition = { x, y: yMin };
			this.ghost.changeDirection(Moves.Up);
		}
	}
}
